import { render, staticRenderFns } from "./sampleRemark.vue?vue&type=template&id=5a9bdf5a"
import script from "./sampleRemark.vue?vue&type=script&lang=js"
export * from "./sampleRemark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports